import { useEffect, useRef, useState } from "react";
import "./App.css";
import JSConfetti from "js-confetti";
import { getFingerprint } from "@thumbmarkjs/thumbmarkjs";
import { ip } from "./api/api";
import HandleAssessment from "./components/embed/HandleAssessment";

var confettiEnabled = false;

export default function Embed2() {
  const [elearningInformation, setElearningInformation] = useState({});
  const [embedStructure, setEmbedStructure] = useState([]);
  const [embedPage, setEmbedPage] = useState("loading");
  const [currentAssessment, setCurrentAssessment] = useState(0);
  const [embedBtnState, setEmbedBtnState] = useState(0);

  const [quizStructure, setQuizStructure] = useState([]);
  const [finished, setFinished] = useState(false);
  const embedIdMatch = window.location.href.match(/\/embed\/([^\/?#]+)/);
  const id = embedIdMatch ? embedIdMatch[1] : null;
  const [maxReachedModule, setMaxReachedModule] = useState(0);
  const jsConfettiRef = useRef(null);


  useEffect(() => {
    getEmbedId();
  }, []);
  useEffect(() => {
    if (window.location.pathname.includes("tap-to-learn")) {
      setEmbedPage("tap-to-learn"); 
    }
  }, []);
  useEffect(() => {
    if (embedPage !== "assessment") return;
    const LS_CA = JSON.parse(localStorage.getItem(`embed_${id}`));
    localStorage.setItem(`embed_${id}`, JSON.stringify({ ...LS_CA, current_module: currentAssessment }));

    if (embedStructure.length === currentAssessment) {
      triggerConfetti();
    }
  }, [currentAssessment]);

  useEffect(() => {
    if (!Array.isArray(embedStructure)) return;
    let globalIndex = 0;
    setQuizStructure([
      {
        title: elearningInformation?.title || "Inhoud",
        collapsed: false,
        progress: 0,
        modules: embedStructure.map((m) => ({ ...m, indexCounter: globalIndex++ }))
      },
    ]);
  }, [embedStructure, elearningInformation?.title]);

  useEffect(() => {
    setMaxReachedModule(prev => Math.max(prev, currentAssessment));
  }, [currentAssessment]);

  const changeFavicon = (src) => {
    let link = document.querySelector("link[rel*='icon']") || document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "icon";
    link.href = src;
    document.head.appendChild(link);
  };

  const embedReady = (title) => {
    let currentTimeout;
    document.title = title;
    document.addEventListener("visibilitychange", function() {
      if (document.hidden) {
        currentTimeout = setTimeout(() => {
          document.title = "Wacht! Je mist iets waardevols";
          changeFavicon("/warning.ico")
        }, 5000)
      } else {
        clearTimeout(currentTimeout)
        document.title = "ZZGeminiTest2PR0";
        changeFavicon("/favicon.ico")
      }
    });
  };

  const getDeviceFP = async () => {
    try { return (await getFingerprint({ logging: false })).hash } catch { return "1"; }
  };

  const generateAccessToken = async () => {
    if (!id) return;
    try {
      const res = await fetch(`${ip}/api/embed/${id}/start`, {
        method: "POST",
        body: JSON.stringify({ d_token: await getDeviceFP(), up: false }),
        headers: { "content-type": "application/json" }
      });
      const token = (await res.json())?.data?.access_token;
      if (token) localStorage.setItem(`embed_${id}`, JSON.stringify({ token, current_module: 0 }));
    } catch (err) { console.error("generateAccessToken error", err); }
  };

  const setupEmbedStructure = async (authToken) => {
    if (!id || !authToken) return;
    try {
      const embed_structure = await (await fetch(`${ip}/api/embed/${id}/structure`, {
        headers: { "X-Auth-Token": authToken }
      })).json();
      const serverData = embed_structure["data"] || [];
      try {
        const stored = JSON.parse(localStorage.getItem(`embed_${id}`)) || {};
        const answers = stored?.answers || {};
        const merged = serverData.map((m, idx) => {
          const saved = answers[idx];
          if (!saved) return m;
          if (Array.isArray(saved?.answer_content) && Array.isArray(m?.module_content?.quiz_answers)) {
            return { ...m, module_content: { ...m.module_content, quiz_answers: saved.answer_content } };
          }
          if (typeof saved?.answer_content === "string" && m?.module_content?.quiz_answers && typeof m.module_content.quiz_answers === "object") {
            return { ...m, module_content: { ...m.module_content, quiz_answers: { ...m.module_content.quiz_answers, quiz_answer: saved.answer_content } } };
          }
          return m;
        });
        setEmbedStructure(merged);
      } catch { setEmbedStructure(serverData); }
    } catch (err) { console.error("setupEmbedStructure error", err); setEmbedStructure([]); }
  };

  const startEmbedAssessment = async () => {
    setEmbedBtnState(1);
    if (!id) return setEmbedPage("not_found");

    if (!localStorage.getItem(`embed_${id}`)) await generateAccessToken();
    const parsed = JSON.parse(localStorage.getItem(`embed_${id}`) || "{}");
    const authToken = parsed?.token;
    if (!authToken) return setEmbedPage("not_found");

    await setupEmbedStructure(authToken);

    setTimeout(() => {
      setEmbedPage("assessment");
      setCurrentAssessment(parsed.current_module || 0);
      setEmbedBtnState(0);
    }, 250);
  };

  const getEmbedId = async () => {
    if (!embedIdMatch || !id) return setEmbedPage("not_found");
    try {
      const embed_information = await (await fetch(`${ip}/api/embed/${id}/information`)).json();
      if (embed_information?.data?.title) {
        setElearningInformation(embed_information.data);
        setEmbedPage("start");
        embedReady(embed_information.data.title);
      } else setEmbedPage("not_found");
    } catch (err) { console.error("getEmbedId error", err); setEmbedPage("not_found"); }
  };

  const triggerConfetti = () => {
    const jsConfetti = jsConfettiRef.current || new JSConfetti();
    jsConfettiRef.current = jsConfetti;
    if (!confettiEnabled) {
      confettiEnabled = true;
      const interval = setInterval(() => jsConfetti.addConfetti(), 150);
      setTimeout(() => { clearInterval(interval); confettiEnabled = false; }, 1000);
    }
  };

  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <HandleAssessment
        embedPage={embedPage}
        finished={finished}
        elearningInformation={elearningInformation}
        embedBtnState={embedBtnState}
        startEmbedAssessment={startEmbedAssessment}
        triggerConfetti={triggerConfetti}
        id={id}
        embedStructure={embedStructure}
        currentAssessment={currentAssessment}
        setEmbedStructure={setEmbedStructure}
        setCurrentAssessment={setCurrentAssessment}
        setFinished={setFinished}
        quizStructure={quizStructure}
        setQuizStructure={setQuizStructure}
        setMaxReachedModule={setMaxReachedModule}
        maxReachedModule={maxReachedModule}
      />
    </div>
  );
}
